import QuoteCartReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/QuoteCartReducer";
import { combineReducers } from "redux";
import ConcreteCalculatorReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ConcreteCalculatorQuoteCartReducer";

const customDataReducerData = {
    quoteCart: QuoteCartReducer,
    concreteCalculation: ConcreteCalculatorReducer,
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
